<script setup lang="ts">
import { useRoute, RouterLink } from "vue-router";
import { ref, onMounted } from "vue";
import RvApi from "@/rvapi";
import type { UserReceivers } from "@/rvapi";
import { utc2local } from "@/utils";

const route = useRoute();
const userId = route.params.id as string;
const userReceivers = ref<UserReceivers | undefined>(undefined);
const loaded = ref(false);
onMounted(async () => {
  userReceivers.value = await RvApi.getUserReceivers(userId);
  loaded.value = true;
});
</script>

<template>
  <h1>
    Saved receivers for user
    <RouterLink :to="'/user/' + userId">
      {{ userId }}
    </RouterLink>
  </h1>
  <pn-spinner size="4" v-show="!loaded" />
  <section v-show="!!loaded">
    <p>User has {{ userReceivers?.receivers?.length || 0 }} receivers saved</p>
    <p v-show="userReceivers?.receivers?.length">
      Last saved: {{ utc2local(userReceivers?.expiresAt) }}
    </p>

    <pn-table
      v-show="userReceivers?.receivers?.length"
      bordered="true"
      striped="true"
    >
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Name2</th>
            <th>Address</th>
            <th>Zip & City</th>
            <th>Country</th>
            <th>Created at</th>
            <th>Last Used</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="recv in userReceivers?.receivers" :key="recv.hash">
            <td>{{ recv.name }}</td>
            <td>{{ recv.name2 || "-" }}</td>
            <td>{{ recv.address }}</td>
            <td>{{ recv.postalCode }} {{ recv.city }}</td>
            <td>{{ recv.countryCode }}</td>
            <td>{{ utc2local(recv.createdAt) }}</td>
            <td>{{ utc2local(recv.lastUsed) }}</td>
          </tr>
        </tbody>
      </table>
    </pn-table>
  </section>
</template>
